
import React from 'react';
import './Demo.css';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const Demo = () => {
  return (
    <div className="app-container">
      <div className="layout">
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
};

export default Demo;